import { useNavigate, useOutletContext } from "react-router-dom";
import SeriesType from "../../images/icons/series_type.svg";

const SelectionType = () => {
  const { isMobile } = useOutletContext();
  const navigate = useNavigate();

  return (
    <div className="selection-type">
      <div
        className={`cards-container page-width_large ${
          isMobile ? "flex-column" : "flex-row"
        }`}
      >
        <div
          onClick={() => navigate("/selection/series")}
          className="selection-type_card"
        >
          <div className="card-content flex-column">
            <img src={SeriesType} alt="series type icon" />
            <h3>Подбор по серии оборудования</h3>
            <p className="text-m">
              Выбор оборудования Aquastrong на основе параметров конкретной
              серии насосов
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectionType;
